import React from "react";
import { useNavigate } from "react-router-dom";
import Calendar from "../../img/Bootcamp js calendario.svg";
import Clock from "../../img/Bootcamp js alarm.svg";
import Duration from "../../img/Bootcamp js duration.svg";
import Modality from "../../img/Bootcamp js modality.svg";
import Days from "../../img/Bootcamp js days.svg";
import Level from "../../img/Bootcamp js level.svg";
import { Box, Typography, Divider, Button, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Morning from "../../img/CourseMorning.svg";
import Night from "../../img/CourseNight.svg";
import { formatDate, formatTime, saveOnLS } from "../../helpers/courses";

const useStyles = (theme) => ({
  apply: {
    width: "293px",
    height: "fit-content",
    borderRadius: "47px",
    background:
      "linear-gradient(to bottom, #071a3e, #071a3e, #071a3e, #071a3e, #071a3e)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflow: "hidden",
    marginLeft: "auto",
    marginRight: "auto",
    schedule: {
      width: "231px",
      height: "31px",
      background: theme.palette.white.main,
      display: "flex",
      alignItems: "center",
      borderRadius: "20.5px",
    },
    listItem: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      margin: "0px 0px 21px 56.2px",
    },
    listText: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-start",
    },
    applyButton: {
      enabled: {
        width: "192px",
        height: "52px",
        borderRadius: "100px",
        background:
          "linear-gradient(100deg, rgba(255,6,46,1) 0%, rgba(208,14,46,1) 100%);",
        color: theme.palette.white.main,
        textTransform: "none",
        fontSize: 15.5,
        fontWeight: 550,
        margin: "0 0 39px",
      },
      disabled: {
        width: "192px",
        height: "52px",
        borderRadius: "100px",
        background:
          "linear-gradient(100deg, rgba(255,6,46,1) 0%, rgba(208,14,46,1) 100%);",
        color: theme.palette.white.main,
        textTransform: "none",
        fontSize: 15.5,
        fontWeight: 550,
        margin: "0 0 39px",
      },
    },
    icon: {
      enabled: {
        p: "5px",
        height: "14px",
        width: "14px",
        borderRadius: "58px",
        color: "#d00e2e",
        bgcolor: theme.palette.white.main,
        ml: "3px",
        boxShadow:
          "4px 8px 20px 0 rgba(0, 0, 0, 0.15), inset 7px 0 20px 0 rgba(255, 255, 255, 0.15)",
      },
      disabled: {
        p: "5px",
        height: "14px",
        width: "14px",
        borderRadius: "58px",
        color: "#d00e2e",
        bgcolor: "#F94B4B",
        ml: "3px",
        boxShadow:
          "4px 8px 20px 0 rgba(0, 0, 0, 0.15), inset 7px 0 20px 0 rgba(255, 255, 255, 0.15)",
      },
    },
  },
  typography: {
    title: {
      color: theme.palette.yellow.main,
      fontFamily: theme.typography.montserrat.regular,
      fontSize: 30,
      fontWeight: 900,
    },
    text: {
      fontFamily: theme.typography.anaHeim.regular,
      fontSize: 24,
      margin: "15px 15px",
    },
    apply: {
      start: {
        color: theme.palette.white.main,
        fontFamily: theme.typography.montserrat.regular,
        fontSize: "1rem",
        margin: "1rem",
      },
      schedule: {
        color: theme.palette.red.main,
        fontFamily: theme.typography.montserrat.regular,
        fontSize: "10px",
        marginLeft: "10px",
      },
      description: {
        color: theme.palette.white.main,
        fontFamily: theme.typography.montserrat.regular,
        fontSize: "18px",
        lineHeight: "24px",
        letterSpacing: "-0.32px",
      },
      value: {
        color: theme.palette.white.main,
        fontFamily: theme.typography.montserrat.bold,
        fontSize: "18px",
        lineHeight: "24px",
        letterSpacing: "-0.32px",
      },
      lastChance: {
        color: theme.palette.white.main,
        fontFamily: theme.typography.sourceSansPro.semibold,
        fontSize: "25px",
        letterSpacing: "7.5px",
        lineHeight: "26px",
      },
    },
  },
});

const BookingMobile = (course) => {
  const {
    info,
    startDate,
    endDate,
    startHour,
    endHour,
    shift,
    weekDays,
    avialability,
    month,
    year,
    bootcampPreparation,
    tag,
  } = course;

  const isMobile = useMediaQuery("(max-width:899px)");
  const theme = useTheme();
  const classes = useStyles(theme, isMobile);
  const navigate = useNavigate();

  const isAvailable =
    info?.availability && info?.vacancyStatus && info?.status === "disponible";

  return (
    <Box sx={classes.apply}>
      <Typography sx={classes.typography.apply.start}>
        <b>
          {month.toUpperCase()} {year} |
        </b>{" "}
        EN VIVO <br></br> 100% ONLINE
      </Typography>
      <Box sx={classes.apply.schedule}>
        <img
          src={shift === "mañana" ? Morning : Night}
          alt="Logo"
          style={{ height: "16x", marginLeft: "10px" }}
        />

        {tag.includes("ATR") ? (
          <Typography sx={classes.typography.apply.schedule}>
            {shift.toUpperCase()}
            <b> | A TU RITMO</b>
          </Typography>
        ) : (
          <Typography sx={classes.typography.apply.schedule}>
            TURNO{" "}
            <b>
              {shift.toUpperCase()} | {formatTime(startHour)} a{" "}
              {formatTime(endHour)}hs
            </b>
          </Typography>
        )}
      </Box>
      <Divider
        variant="middle"
        sx={{
          width: "224px",
          height: "0.5px",
          margin: "15.5px 0px 36px",
          backgroundColor: theme.palette.white.main,
        }}
      />
      <Box sx={classes.apply.listItem}>
        <img
          src={Calendar}
          alt="calendar"
          style={{ width: "21px", height: "21px", margin: "2.5px 7.6px 0 0" }}
        />
        <Box sx={classes.apply.listText}>
          <Typography sx={classes.typography.apply.description}>
            Fechas:
          </Typography>
          <Typography sx={classes.typography.apply.value}>
            {formatDate(startDate)} a {formatDate(endDate)}
          </Typography>
        </Box>
      </Box>
      <Box sx={classes.apply.listItem}>
        <img
          src={Clock}
          alt="calendar"
          style={{ width: "21px", height: "21px", margin: "2.5px 7.6px 0 0" }}
        />
        <Box sx={classes.apply.listText}>
          <Typography sx={classes.typography.apply.description}>
            Horario:
          </Typography>
          <Typography sx={classes.typography.apply.value}>
            de {formatTime(startHour)} a {formatTime(endHour)}hs
          </Typography>
        </Box>
      </Box>
      <Box sx={classes.apply.listItem}>
        <img
          src={Duration}
          alt="calendar"
          style={{ width: "21px", height: "21px", margin: "2.5px 7.6px 0 0" }}
        />
        <Box sx={classes.apply.listText}>
          <Typography sx={classes.typography.apply.description}>
            Duración:
          </Typography>
          <Typography sx={classes.typography.apply.value}>
            6 semanas (57 horas)
          </Typography>
        </Box>
      </Box>
      <Box sx={classes.apply.listItem}>
        <img
          src={Modality}
          alt="calendar"
          style={{ width: "21px", height: "21px", margin: "2.5px 7.6px 0 0" }}
        />
        <Box sx={classes.apply.listText}>
          <Typography sx={classes.typography.apply.description}>
            Modalidad:
          </Typography>
          <Typography sx={classes.typography.apply.value}>Part-time</Typography>
        </Box>
      </Box>
      <Box sx={classes.apply.listItem}>
        <img
          src={Days}
          alt="calendar"
          style={{ width: "21px", height: "21px", margin: "2.5px 7.6px 0 0" }}
        />
        <Box sx={classes.apply.listText}>
          <Typography sx={classes.typography.apply.description}>
            Dias:
          </Typography>
          <Typography sx={classes.typography.apply.value}>
            {weekDays}
          </Typography>
        </Box>
      </Box>
      <Box sx={classes.apply.listItem}>
        <img
          src={Level}
          alt="calendar"
          style={{ width: "21px", height: "21px", margin: "2.5px 7.6px 0 0" }}
        />
        <Box sx={classes.apply.listText}>
          <Typography sx={classes.typography.apply.description}>
            Nivel:
          </Typography>
          <Typography sx={classes.typography.apply.value}>inicial</Typography>
        </Box>
      </Box>
      <Divider
        variant="middle"
        sx={{
          width: "224px",
          height: "0.5px",
          margin: "10px 0px 27px",
          backgroundColor: theme.palette.white.main,
        }}
      />
      <Typography sx={classes.typography.apply.start}>
        <ErrorOutlineIcon sx={{ height: "1.2rem" }} />
        {bootcampPreparation}
      </Typography>
      <Divider
        variant="middle"
        sx={{
          width: "224px",
          height: "0.5px",
          margin: "27px 0px 29px",
          backgroundColor: theme.palette.white.main,
        }}
      />
      {info?.vacancyStatus && isAvailable ? (
        <Button
          disabled={avialability ? false : true}
          onClick={() => {
            saveOnLS(info, () => navigate("/aplica/intro/formulario"));
          }}
          sx={
            isAvailable
              ? classes.apply.applyButton.enabled
              : classes.apply.applyButton.disabled
          }
          endIcon={
            <ArrowForwardIosIcon
              sx={
                isAvailable
                  ? classes.apply.icon.enabled
                  : classes.apply.icon.disabled
              }
            />
          }
        >
          Aplicar
        </Button>
      ) : (
        <Typography
          sx={{ ...classes.typography.apply.lastChance, marginBottom: "40px" }}
        >
          {info?.vacancyStatus ? "ULTIMAS VACANTES" : "NO HAY VACANTES"}
        </Typography>
      )}
    </Box>
  );
};

export default BookingMobile;
